const productSettings = {
  pageTitle: "Paramètres Lappa",
  backToSettings: "Paramètres",
  pageHelmetTitle: "Historique de facturation",
  pageTitles: {
    applications: "Applications",
    billings: "Facturation",
    plansAndUsage: "Plans et consommation",
    payments: "Paiements",
    sandbox: "Sandbox",
  },
  customerBillingNote:
    "Seules les données de facturation de votre entreprise sont affichées ici (pas les documents clients).",
  mainTabs: {
    applications: "Applications",
    billingHistory: "Historique de facturation",
    plansAndUsage: "Plans et consommation",
    payments: "Paiements",
    sandbox: "Sandbox",
  },
  sandbox: {
    cancel: "Annuler",
    navigation: {
      switchTo: "Passer à la sandbox",
      currentSandbox: "Sandbox active",
      switchBack: "Revenir à l'entreprise réelle",
      active: "Sandbox active",
      open: "Passer à cette sandbox",
      empty: "Aucune sandbox n'a encore été créée.",
      create: "Créer une sandbox",
      manage: "Gérer les sandboxes",
      singleLimit: "Une seule sandbox peut être créée par entreprise.",
    },
    access: {
      title: "Cette fonctionnalité n'est pas disponible dans la Sandbox",
      disabledDescription:
        "Revenez à votre entreprise active pour accéder à cette fonctionnalité.",
      noPermission:
        "Vous n'êtes pas autorisé à utiliser cette fonctionnalité dans la Sandbox.",
      disabledHint: "Non disponible dans la Sandbox",
    },
    create: {
      configurationTitle: "Configuration initiale",
      configurationDescription: "Choisissez le contenu de la nouvelle sandbox.",
      copyAccount: "Copier le compte",
      copyAccountDescription:
        "Les paramètres et fonctionnalités seront copiés du compte réel.",
      newSandbox: "Créer une nouvelle sandbox",
      newSandboxDescription: "Aucune donnée du compte réel ne sera copiée.",
      next: "Suivant",
      nameTitle: "Nommer la sandbox",
      nameDescription:
        "Nous avons généré un nom, mais vous pouvez le modifier maintenant ou plus tard.",
      nameLabel: "Nom de la sandbox",
      nameRequired: "Saisissez un nom pour la sandbox.",
      nameTooLong: "Le nom de la sandbox doit contenir 80 caractères au maximum.",
      regenerate: "Régénérer",
      back: "Retour",
      submit: "Créer la sandbox",
    },
    manage: {
      title: "Gérer les sandboxes",
      description:
        "Créez un environnement isolé pour tester sans modifier les données réelles.",
      emptyTitle: "Aucune sandbox",
      emptyDescription: "Créez une sandbox pour tester vos réglages et processus.",
      sandboxDescription: "Isolée des données de l'entreprise réelle",
      delete: "Supprimer la sandbox",
      deleteTitle: "Supprimer la sandbox",
      deleteDescription:
        "Cette sandbox et toutes ses données seront définitivement supprimées. Cette action est irréversible.",
      deleteActiveHint:
        "Revenez à l'entreprise réelle avant de supprimer cette sandbox.",
      created: "Sandbox créée avec succès.",
      deleted: "Sandbox supprimée avec succès.",
      retry: "Réessayer",
    },
  },
  plansAndUsage: {
    innerTabs: {
      overview: "Aperçu",
      includedInPlan: "Inclus dans le plan",
      usageAndLimits: "Consommation",
    },
    emptyProduct: "Aucun abonnement actif pour ce produit.",
    emptyProductHint: "Choisissez un plan pour commencer à utiliser ce produit.",
    includedPlaceholder: "Inclus dans le plan — bientôt disponible.",
    usagePlaceholder: "Consommation — bientôt disponible.",
    overview: {
      subscriptionTitle: "Abonnement",
      creditsTitle: "Crédits",
      addonsTitle: "Modules complémentaires",
      activeBadge: "Actif",
      inactiveBadge: "Inactif",
      nextBillingDate: "Prochaine date de facturation",
      billingCycle: "Cycle de facturation",
      billingCycleYearly: "Annuel",
      billingCycleMonthly: "Mensuel",
      perYear: "/ an",
      perMonth: "/ mois",
      creditSingular: "crédit",
      creditPlural: "crédits",
      manageCredits: "Gérer les crédits",
      changeSubscription: "Modifier l'abonnement",
      choosePlan: "Choisir un plan",
      buyAddons: "Acheter des add-ons",
      cancelSubscription: "Résilier l'abonnement",
      planLabel: "Forfait",
      statusLabel: "Statut",
      priceLabel: "Prix",
      createdLabel: "Créé",
      includedCountries: "Pays inclus",
      includedUsers: "Utilisateurs inclus",
      vatReturns: "Déclarations de TVA",
      statesIncluded: "États inclus",
      registrationsIncluded: "Immatriculations",
      autoFiling: "Dépôt automatique",
      includedFeaturesTitle: "Fonctionnalités incluses",
      subscriptionDetailsTitle: "Détails de l'abonnement",
      summaryTitle: "Récapitulatif de facturation",
      planCost: "Coût du plan",
      addonsTotal: "Total des modules",
      total: "Total",
    },
  },
  tabs: {
    proforma: "Facture proforma",
    taxInvoice: "Facture fiscale",
    creditNote: "Avoir",
    payments: "Paiements",
    creditsSummary: "Synthèse des crédits",
  },
  proforma: {
    addonsLabel: "Add-ons:",
    viewPayment: "Voir",
  },
  filters: {
    searchPlaceholder: "Rechercher",
    proformaSearchPlaceholder: "Rechercher par numéro de facture ou nom",
    dateRangeLabel: "Plage de dates",
    dateFrom: "Du",
    dateTo: "Au",
    sortByStatus: "Filtrer par statut",
    sortByStatusPrefix: "Trier par statut:",
    statusAll: "Tous",
    showAll: "Tout afficher",
    appsPrefix: "Applications:",
    proformaStatusNew: "Nouveau",
    proformaStatusProcessed: "Traité",
    proformaStatusVoided: "Annulé",
    proformaStatusRefund: "Remboursement",
    proformaStatusBalanceRefund: "Remboursement du solde",
    proformaAppLTax: "L'Tax",
    proformaAppLEpr: "L'EPR",
    proformaAppLInvoice: "L'Invoice",
    proformaAppLAuthorize: "L'Authorize",
    advancedFiltersTrigger: "Filtres avancés",
    advancedFiltersTitle: "Filtres avancés",
    advanced: {
      subscriptionType: "Type d'abonnement",
      subscriptionPlaceholder: "Sélectionner un abonnement",
      addons: "Modules complémentaires",
      addonsPlaceholder: "Sélectionner des modules",
      amount: "Montant",
      amountPlaceholder: "Saisir le montant",
      optionNone: "\u2014",
      addonMockReports: "Reporting",
      addonMockCompliance: "Conformité",
    },
  },
  filterTabs: {
    moreOptions: "Plus d’options",
  },
  statuses: {
    PAID: "Payé",
    PENDING: "En attente",
    OPEN: "Ouvert",
    COMPLETED: "Terminé",
    CLOSED: "Clôturé",
    FAILED: "Échoué",
    CANCELLED: "Annulé",
    paid: "Payé",
    due: "Dû",
    credited: "Crédité",
  },
  statusFilter: {
    ALL: "Tous",
    PAID: "Payé",
    PENDING: "En attente",
    OPEN: "Ouvert",
    COMPLETED: "Terminé",
    CLOSED: "Clôturé",
  },
  table: {
    created: "Créé le",
    invoiceName: "Nom de la facture",
    creditNoteName: "Nom de l'avoir",
    relatedInvoice: "Facture associée",
    number: "Numéro",
    billingPeriod: "Période de facturation",
    status: "Statut",
    payment: "Paiement",
    app: "Application",
    amount: "Montant",
    actions: "Actions",
  },
  billingTableEmpty: {
    title: "Aucun résultat",
    proformaTitle: "Aucun élément trouvé",
    proformaEmptyDescription: "Vous n’avez actuellement aucune facture proforma.",
    emptyNoSearch: "Vous n’avez actuellement aucun {{entity}}.",
    searchNoMatch: "Votre recherche « {{query}} » ne correspond à aucun élément.",
    clearSearch: "Effacer la recherche",
    entities: {
      _default: "enregistrement pour cet onglet",
      PROFORMA: "factures proforma",
      TAX: "factures fiscales",
      CREDIT_NOTE: "avoirs",
      PAYMENTS: "paiements",
      CREDITS_SUMMARY: "entrées du récapitulatif des crédits",
    },
  },
  loading: "Chargement de l’historique de facturation…",
  error: "Impossible de charger l’historique de facturation. Veuillez réessayer.",
  retry: "Réessayer",
  billingRowActions: {
    viewDetails: "Voir les détails",
    view: "Voir",
    pay: "Payer",
    edit: "Modifier",
    void: "Annuler",
    restore: "Restaurer",
    download: "Télécharger",
    delete: "Supprimer",
  },
  rowActions: {
    download: "Télécharger",
    view: "Voir les détails",
    copyNumber: "Copier le numéro de facture",
  },
  payments: {
    table: {
      type: "Type",
      paymentMethod: "Mode de paiement",
    },
  },
  creditsSummary: {
    cards: {
      salesTaxAvailable: "Crédits Sales Tax disponibles",
      salesListAvailable: "Crédits Sales list disponibles",
    },
    filters: {
      sortByTypePrefix: "Trier par type :",
      sortAll: "Tous",
      sortSalesTax: "Sales Tax",
      sortSalesList: "Sales List",
    },
    table: {
      description: "Description",
      id: "ID",
      creditType: "Type de crédit",
      creditsLeft: "Crédits restants",
      amount: "Montant",
    },
  },
  taxInvoiceDetails: {
    status: "Statut",
    invoiceDate: "Date de facture",
    invoiceNumber: "Numéro de facture",
    vatNumber: "Numéro de TVA",
    sectionTitle: "Détails de la facture",
    colItem: "Article",
    colQty: "Qté",
    colPrice: "Prix",
    total: "Total",
    downloadPdf: "Télécharger le PDF",
  },
  creditNoteDetails: {
    status: "Statut",
    createdDate: "Créé",
    number: "Numéro",
    relatedInvoice: "Facture associée",
    sectionTitle: "Détails de l'avoir",
    colItem: "Article",
    colQty: "Qté",
    colPrice: "Prix",
    total: "Total",
    downloadPdf: "Télécharger le PDF",
  },
  proformaInvoiceDetails: {
    title: "Facture proforma",
    titleWithNumber: "Facture proforma {{number}}",
    app: "App",
    addonsHeading: "Modules complémentaires",
    noInvoiceDetails: "Aucun détail de facture",
  },
  proformaDeleteModal: {
    title: "Supprimer la facture proforma",
    description:
      "Cette facture proforma sera définitivement supprimée. Cette action est irréversible.",
    descriptionWithNumber:
      "La facture proforma {{number}} sera définitivement supprimée. Cette action est irréversible.",
    cancel: "Annuler",
    delete: "Supprimer",
  },
  proformaVoidModal: {
    title: "Annuler la facture proforma ?",
    description:
      "Cette action marquera la facture proforma comme annulée. Vous pourrez la restaurer plus tard si nécessaire.",
    descriptionWithNumber:
      "La facture proforma {{number}} sera marquée comme annulée. Vous pourrez la restaurer plus tard si nécessaire.",
    cancel: "Annuler",
    void: "Annuler la facture",
    success: "Facture proforma marquée comme annulée avec succès.",
    errorGeneric: "Impossible d’annuler cette facture. Veuillez réessayer.",
  },
  proformaRestoreModal: {
    title: "Restaurer la facture proforma ?",
    description:
      "Cette action restaurera la facture proforma et rétablira son statut sur Nouveau.",
    cancel: "Annuler",
    restore: "Restaurer la facture",
    success: "Facture proforma restaurée avec succès.",
    errorGeneric: "Impossible de restaurer cette facture. Veuillez réessayer.",
  },
  proformaPayModal: {
    title: "Payer la facture proforma",
    description:
      "Voulez-vous payer la facture proforma {{number}} du {{date}} pour {{amount}} ?",
    numberFallback: "\u2014",
    cancel: "Annuler",
    pay: "Payer",
    shopifyPay: "Acheter maintenant avec Shopify Pay",
  },
  proformaInvoiceEdit: {
    drawerTitle: "Modifier la facture proforma",
    cancel: "Annuler",
    save: "Enregistrer",
    pdfLabel: "Facture PDF",
    removeFile: "Retirer",
    errorTitle: "Échec de l’enregistrement",
    errorGeneric: "Impossible d’enregistrer les modifications.",
    errorNumberRequired: "Saisissez le numéro de facture.",
    errorSumRequired: "Saisissez le montant.",
    errorSumInvalid: "Saisissez un montant valide.",
    errorUploadAfterSave: "La facture a été enregistrée mais le téléversement du PDF a échoué.",
    createdDateLabel: "Date de création",
    createdDatePlaceholder: "Choisir la date de création",
    paymentDateLabel: "Date de paiement",
    paymentDatePlaceholder: "Choisir la date de paiement",
  },
  mainTabSoon: "Bientôt disponible",
};

export default productSettings;
